import * as Service from 'types/service';
import { ServiceDefinedState } from 'state/service/config';
import { StoreType } from '@tock/shared/utils/connect';
import { createSecondaryStates, filterPartyStates } from 'utils/businessDefinedStateUtils';
import { createSelector } from 'reselect';
import {
  getDefaultEmotionDisplayInformation,
  getDisplayInfoForPartyState,
  getStateName,
  getVariableColorFromBusinessStringColor,
} from 'utils/partyUtils';
import PartyStates from 'constants/partyStateConstants';
import _ from 'lodash';

export const secondaryStatesSelector = createSelector(
  (state: StoreType) => state.service.config.businessDefinedStates,
  (businessDefinedStates: ServiceDefinedState[]): Service.StateGroupingMap => {
    const secondaryStates: Service.StateDescription[] =
      createSecondaryStates(businessDefinedStates);
    const partyStateEnums = _.values(PartyStates);
    const primaryStates: Service.StateDescription[] = _.map(partyStateEnums, (primaryState) => {
      const customizationOfState = _.find(
        businessDefinedStates,
        (stateConfig) => primaryState === stateConfig.primaryState && _.isNil(stateConfig.stateName)
      );
      const displayInfo = getDisplayInfoForPartyState(primaryState, customizationOfState);
      return {
        ...displayInfo,
        primaryState,
        secondaryValue: null,
      };
    });
    const split = filterPartyStates(_.concat(primaryStates, secondaryStates));
    return {
      EXPECTED: _.sortBy(split.expected, 'ordering'),
      SEATED: _.sortBy(split.seated, 'ordering'),
      NO_SHOW: _.sortBy(split.noshow, 'ordering'),
      LEFT: _.sortBy(split.left, 'ordering'),
      CANCELED: _.sortBy(split.canceled, 'ordering'),
    };
  }
);

export const emotionPartyStatesSelector = createSelector(
  (state: StoreType) => state.service.config.businessDefinedStates,
  (businessDefinedStates: ServiceDefinedState[]): ServiceDefinedState[] => {
    const partyStateEnums = _.values(PartyStates);

    const missingPartyStates = partyStateEnums.filter(
      (partyPrimaryState) =>
        !businessDefinedStates.find(
          (definedPartyState) => partyPrimaryState === definedPartyState.primaryState
        )
    );

    return [
      ...businessDefinedStates.map((businessDefinedState) => {
        return {
          ...businessDefinedState,
          color: getVariableColorFromBusinessStringColor(businessDefinedState.color),
          stateName:
            businessDefinedState.stateName ?? getStateName(businessDefinedState.primaryState),
        };
      }),
      ...missingPartyStates.map((partyState) => getDefaultEmotionDisplayInformation(partyState)),
    ];
  }
);
